import React from "react";

const NotFound = () => {
  return <div>page 404</div>;
};

export default NotFound;
